(() => {
  'use strict';

  const countdown = document.querySelector('.countdown');
  if (countdown) {
    // The explicit UTC offset fixes the launch to 10:00 Europe/Zurich (CEST),
    // regardless of the visitor's own time zone. Recalculate from the clock on
    // every tick so background-tab throttling never makes the timer drift.
    const target = Date.parse(countdown.dataset.target);
    const units = ['days', 'hours', 'minutes', 'seconds'];
    const fields = units.map(unit => countdown.querySelector(`[data-unit="${unit}"]`));
    let timer;
    let announced = false;

    function updateCountdown() {
      if (!Number.isFinite(target)) return;
      const seconds = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });

      if (seconds === 0) {
        clearInterval(timer);
        countdown.querySelector('[data-countdown-note]').textContent = 'Die Wartezeit ist vorbei. Der Launch-Termin ist da!';
        if (!announced) {
          document.querySelector('#launch-status').textContent = 'Der Launch-Termin am 2. Oktober 2026 um 10 Uhr Schweizer Zeit ist erreicht.';
          announced = true;
        }
      }
      return seconds;
    }

    if (updateCountdown() > 0) timer = setInterval(updateCountdown, 1000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateCountdown();
    });
  }

  document.querySelectorAll('.calendar-link').forEach(link => link.addEventListener('click', () => {
    document.querySelector('.calendar-feedback').textContent = 'Kalenderdatei bereit. Öffne sie und bestätige den Termin in deinem Kalender.';
  }));
})();
